import React from 'react'
import { Modal } from '@mobi/component-library/Overlays/Modal'
import { Button } from '@mobi/component-library/Base/Buttons'

export const FirstPostConfirmation: React.FC<{
  isOpen: boolean
  onConfirm(): void
  onCancel(): void
  zIndex?: React.ComponentProps<typeof Modal>['zIndex']
}> = ({ isOpen, onConfirm, onCancel, zIndex }) => {
  return (
    <Modal
      isOpen={isOpen}
      headerIcon='warning'
      headerTitle='Are you sure you want to share?'
      headerSubtitle='All shares to Bet Loop are final and will be visible to everyone.'
      dismissStatus='disallowed'
      zIndex={zIndex}
      footerComponent={
        <>
          <Button
            size='md'
            isFullWidth
            color='secondary_grey'
            onClick={onCancel}
            data-testid='BetLoopFirstShare.Cancel'
          >
            Cancel
          </Button>

          <Button
            size='md'
            isFullWidth
            color='primary'
            onClick={onConfirm}
            data-testid='BetLoopFirstShare.Submit'
          >
            Share to Bet Loop
          </Button>
        </>
      }
    />
  )
}
